var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSensorSet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SENSOR-SET",
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #SENSOR-SET .cls-1 {\n        fill: #7826ff;\n      }\n\n      #SENSOR-SET .cls-2 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-7 1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42,0A42,42,0,1,0,84,42,42,42,0,0,0,42,0",
    transform: "translate(7 -1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.189,34.707S19.042,50.646,19.042,56.873a11.148,11.148,0,1,0,22.3,0c0-6.227-11.148-22.166-11.148-22.166M38.015,56.1a2.865,2.865,0,1,1-2.863-2.9,2.881,2.881,0,0,1,2.863,2.9M39.394,29.87a2.449,2.449,0,0,1-1.733-.718,10.819,10.819,0,0,0-14.945,0,2.45,2.45,0,0,1-3.465-3.465,15.463,15.463,0,0,1,21.875,0,2.45,2.45,0,0,1-1.732,4.182m6.9-6.9a2.461,2.461,0,0,1-1.732-.718,20.353,20.353,0,0,0-28.752,0,2.45,2.45,0,1,1-3.465-3.465,25.265,25.265,0,0,1,35.683,0A2.45,2.45,0,0,1,46.3,22.968M53.2,16.063a2.452,2.452,0,0,1-1.733-.714,30.119,30.119,0,0,0-42.56,0,2.451,2.451,0,0,1-3.469-3.465,35.035,35.035,0,0,1,49.493,0A2.447,2.447,0,0,1,53.2,16.063",
    transform: "translate(18.811 3.122)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSensorSet);
export default __webpack_public_path__ + "static/media/sensor-set.449ec4fcc154078ec161fae12d1288c2.svg";
export { ForwardRef as ReactComponent };